export const API_STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const ACCOUNT_TYPE = { 
  CITIZEN: 'Citizen',
  NODAL_OFFICER: 'Nodal Officers',       
  DISTRICT_MAGISTRATE: 'District Magistrate', 
};

export const GRIEVANCE_CATEGORIES = [
  'Public Works',
  'Sanitation',
  'Water Supply',
  'Electricity',
  'Roads',
  'Health',
  'Education',
  'Other',
];

export const GRIEVANCE_STATUSES = [
  'Submitted',
  'Assigned',
  'In Progress',
  'Resolved',
  'Rejected',
  'Reopened',
];

export const GRIEVANCE_SEVERITY = [
  'Low',
  'Medium',
  'High',
  'Critical',
];
